import { render, staticRenderFns } from "./clientAddress.vue?vue&type=template&id=04395018&"
import script from "./clientAddress.vue?vue&type=script&lang=js&"
export * from "./clientAddress.vue?vue&type=script&lang=js&"
import style0 from "./clientAddress.vue?vue&type=style&index=0&id=04395018&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports